// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/tmp/3e005e78/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/tmp/3e005e78/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-talks-js": () => import("/tmp/3e005e78/src/pages/talks.js" /* webpackChunkName: "component---src-pages-talks-js" */),
  "component---src-pages-work-js": () => import("/tmp/3e005e78/src/pages/work.js" /* webpackChunkName: "component---src-pages-work-js" */)
}

